// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
// import順を変えないように注意↓↓
import Vuetify, {
  VApp,
  VAlert,
  VAvatar,
  VAutocomplete,
  VBtn,
  VBtnToggle,
  VCard,
  VCardActions,
  VCardText,
  VCardTitle,
  VChip,
  VCheckbox,
  VContainer,
  VContent,
  VDatePicker,
  VDataTable,
  VDialog,
  VDivider,
  VExpandTransition,
  VExpansionPanel,
  VExpansionPanelContent,
  VFabTransition,
  VFlex,
  VFooter,
  VForm,
  VIcon,
  VHover,
  VImg,
  VLayout,
  VLabel,
  VList,
  VListTile,
  VListTileTitle,
  VMenu,
  VPagination,
  VProgressCircular,
  VProgressLinear,
  VRadio,
  VRadioGroup,
  VSheet,
  VSelect,
  VSnackbar,
  VSpacer,
  VStepper,
  VStepperHeader,
  VStepperStep,
  VSubheader,
  VSwitch,
  VTab,
  VTabsItems,
  VTabItem,
  VTabs,
  VTextarea,
  VTextField,
  VTreeview,
  VToolbar,
  VToolbarItems,
  VToolbarTitle,
  VTooltip,
  VWindow,
  VWindowItem,
  VBreadcrumbs,
  VListTileContent,
  VListTileAction,
  VNavigationDrawer,
  VBadge,
  VCombobox,
  VParallax,
  VSlider
} from 'vuetify/lib';
import { Ripple, Scroll } from 'vuetify/lib/directives';
import 'vuetify/dist/vuetify.min.css';
import App from './App';
import router from './router';
import store from './store/';
import extend from './extend';
// ここまで↑↑
import VueScrollTo from 'vue-scrollto';

import { toDefault, toDateTime, toDate, toTime, toDay, toNow } from './filters/date/date.filter';
import './assets/css/brand.css';
import './assets/css/base.css';
import './assets/css/new_base.css';

import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';

Vue.config.productionTip = process.env.NODE_ENV !== 'local';

Vue.prototype.$cdnEndpoint = process.env.CDN_ENDPOINT;

Vue.use(Vuetify, {
  theme: {
    // Lisse パレット。値は src/assets/css/brand.css の :root と一致させること。
    // トークン名は Vuetify 1系の既存名を踏襲しているため、名前と実際の色相は一致しない
    // （例: night_b はダークインク、calm_blue は Lisse Yellow）。
    primary: '#FFAF34',
    primary_ink: '#B87400',
    on_primary: '#402D00',
    ivory: '#F2E6D1',
    ink: '#26241F',
    lemon: '#FCF3E0',
    warning: '#FFCC00',
    yellow: '#FFE9B8',
    orange: '#FFAF34',
    red: '#E14A46',
    night_b: '#26241F',
    night_h: '#605D54',
    night_6h: '#9A968C',
    night_10h: '#EDEBE6',
    blue: '#1e90ff',
    light_blue: '#CCE4FF',
    middle_blue: '#70A1FF',
    dark_blue: '#26241F',
    light_purple: '#FFEACB',
    white: '#FFFFFF',
    grey: '#E0DDD6',
    grey_text: '#26241F',
    grey_text_light: '#9A968C',
    grey_back: '#EDEBE6',
    border_mid: '#CFCCC3',
    border_dark: '#B5B1A6',
    disabled_light: '#D9D6CE',
    calm_blue: '#FFAF34'
  },
  components: {
    VApp,
    VAlert,
    VAvatar,
    VAutocomplete,
    VBtn,
    VBtnToggle,
    VCard,
    VCardActions,
    VCardText,
    VCardTitle,
    VChip,
    VCheckbox,
    VContainer,
    VContent,
    VDatePicker,
    VDataTable,
    VDialog,
    VDivider,
    VExpandTransition,
    VExpansionPanel,
    VExpansionPanelContent,
    VFabTransition,
    VFlex,
    VFooter,
    VForm,
    VHover,
    VIcon,
    VImg,
    VLayout,
    VLabel,
    VList,
    VListTile,
    VListTileTitle,
    VMenu,
    VPagination,
    VProgressCircular,
    VProgressLinear,
    VRadio,
    VRadioGroup,
    VSheet,
    VSelect,
    VSnackbar,
    VSpacer,
    VStepper,
    VStepperHeader,
    VStepperStep,
    VSubheader,
    VSwitch,
    VTab,
    VTabsItems,
    VTabItem,
    VTabs,
    VTextarea,
    VTextField,
    VTreeview,
    VToolbar,
    VToolbarItems,
    VToolbarTitle,
    VTooltip,
    VWindow,
    VWindowItem,
    VBreadcrumbs,
    VListTileContent,
    VListTileAction,
    VNavigationDrawer,
    VBadge,
    VCombobox,
    VParallax,
    VSlider
  },
  directives: {
    Ripple,
    Scroll
  }
});
Vue.use(VueScrollTo);

/* 日付関連のfilter */
Vue.filter('default', toDefault);
Vue.filter('dateTime', toDateTime);
Vue.filter('date', toDate);
Vue.filter('time', toTime);
Vue.filter('day', toDay);
Vue.filter('now', toNow);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: {
    App
  },
  template: '<App/>',
  extend
});

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_APIKEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
